import { render, staticRenderFns } from "./SponsorImageSelector.vue?vue&type=template&id=d4a0ed32&scoped=true&"
import script from "./SponsorImageSelector.vue?vue&type=script&lang=js&"
export * from "./SponsorImageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a0ed32",
  null
  
)

export default component.exports